import { html, ViewTemplate, repeat, ref } from '@microsoft/fast-element';
import { expandIcon, minusSignIcon } from '../../../../styles';
import type { BuyerInterest } from './buyer-interest';
import { sync } from '@genesislcap/foundation-utils';
import { RFQ_COLUMNS } from './column-config';

export const BuyerInterestTemplate: ViewTemplate<BuyerInterest> = html`
  <div class="buyer-interest">
    <zero-tabs>
      <span slot="start" class="tab-title">Buyer Interest</span>
      <tab-buttons slot="end">
        <zero-button slot="buttons" appearance="tab-primary">
          ${expandIcon('end')} Expand RFQ's
        </zero-button>
      </tab-buttons>
    </zero-tabs>
    <div class="buyer-interest-data">
      <div class="buyer-interest-criteria">
        <div class="form-control">
          <span class="light-gray-title">Popular Criteria</span>
        </div>

        <div class="form-control">
          <label class="form-label">Technology</label>
          <zero-segmented-control
            appearance="primary"
            orientation="horizontal"
            :value="${sync((x) => x.technologyValue)}"
            @change="${(x) => x.populateGrid()}"
          >
            <zero-segmented-item value="WIND">Wind</zero-segmented-item>
            <zero-segmented-item value="SOLAR">Solar</zero-segmented-item>
          </zero-segmented-control>
        </div>

        <div class="form-control">
          <label>ISO</label>
          <zero-select
            class="input-control buyer-interest-select"
            :value=${sync((x) => x.isoValue)}
            @change="${(x) => x.populateGrid()}"
            position="below"
          >
            <zero-option value="">Select ISO</zero-option>
            ${repeat(
              (x) => x._ISO,
              html`
                <zero-option value="${(x) => x.VALUE}">${(x) => x.VALUE}</zero-option>
              `
            )}
          </zero-select>
        </div>

        <zero-text-field
          class="input-control"
          type="number"
          :value=${sync((x) => x.lmeValue)}
          @change="${(x) => x.populateGrid()}"
        >
          <div slot="start" class="lme-start"><span class="lme-icon">></span></div>
          LME
        </zero-text-field>

        <div class="form-control">
          <label class="form-label">Request Capacity</label>
          <div class="request-capacity">
            <zero-text-field
              class="input-control"
              type="number"
              :value=${sync((x) => x.minCapacityValue)}
              @change="${(x) => x.populateGrid()}"
            ></zero-text-field>
            <div class="minus-sign">${minusSignIcon('')}</div>
            <zero-text-field
              class="input-control"
              type="number"
              :value=${sync((x) => x.maxCapacityValue)}
              @change="${(x) => x.populateGrid()}"
            ></zero-text-field>
          </div>
        </div>
      </div>
      <div class="buyer-interest-grid">
        <zero-grid-pro
          class="grid-styles"
          only-template-col-defs
          sideBar=""
          rowSelection="single"
          @onGridReady="${(x) => x.onGridReady()}"
          ${ref('rfqGrid')}
        >
          ${repeat(
            (x) => RFQ_COLUMNS(x),
            html`
              <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
            `
          )}
        </zero-grid-pro>
        \`
      </div>
    </div>
  </div>
`;
